import styled from "styled-components";
import { palette } from "styled-theme";

const TopbarWrapper = styled.div`
  z-index: 999;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16) !important;
  .header {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    background-color: ${palette("surfaceColor", 0)} !important;
    border-bottom: 1px solid ${palette("border", 0)};
    .left {
      display: flex;
      align-items: center;
      margin: 0 20px;
      .ant-space-item {
        line-height: initial !important;
      }
      li {
        margin-left: ${(props) => (props["data-rtl"] === "rtl" ? "0" : "10px")};
        margin-right: ${(props) =>
          props["data-rtl"] === "rtl" ? "10px" : "0"};
        cursor: pointer;
        line-height: normal;
        position: relative;
        display: inline-block;
      }
    }

    .right {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      z-index: 2;
      li {
        margin-left: ${(props) => (props["data-rtl"] === "rtl" ? "10px" : "0")};
        margin-right: ${(props) =>
          props["data-rtl"] === "rtl" ? "0" : "10px"};
        cursor: pointer;
        line-height: normal;
        position: relative;
        display: inline-block;
      }
      .branchContainer {
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 20px;
        border-radius: 5px;
        border: 1px dashed ${palette("border", 0)};
        cursor: auto;
      }
    }
  }
`;

export default TopbarWrapper;
